export enum SignPositionTypes {
  IMAGE = 'image',
  DIGITAL = 'digital',
  COMBINE = 'combine',
}
